<template>
	<div class="dialog-form-only">
		<el-dialog
			:visible.sync="copyVisible"
			:title="attributes.title"
			:width="attributes.width"
			:modal="attributes.modal"
			:custom-class="attributes.customCalss"
			:show-close="attributes.showClose"
			:fullscreen="attributes.fullscreen"
			:close-on-click-modal="attributes.clickModal"
			:close-on-press-escape="attributes.pressEscape"
			:destroy-on-close="attributes.destroy"
			v-bind="attributes"
			@close="close"
		>
			<!-- form表单 -->
			<form-combination
				ref="formName"
				:form-data="formData"
				:showBtn="attributes.showBtn"
				:labelWidth="attributes.labelWidth"
				@launchWhatsAppSignup="launchWhatsAppSignup"
			></form-combination>
			<!-- component -->
			<component :is="colType" v-bind="attributes"></component>
			<!-- 插槽 -->
			<slot slot="title" name="title"></slot>
			<slot name="main"></slot>
			<slot name="bottom"></slot>
			<!-- 按钮 -->
			<span slot="footer" class="dialog-footer" v-if="showBtn">
				<el-button
					v-if="!hideClose"
					@click="cancel"
					:loading="btnLoading"
					:disabled="attributes.cancelDisabled"
					>{{ attributes.cancelBtn || '取 消' }}</el-button
				>
				<el-button
					type="primary"
					@click="confirm"
					:loading="btnLoading"
					:disabled="attributes.confirmDisabled"
					>{{ attributes.confirmBtn || '确 定' }}</el-button
				>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import formCombination from '@/components/iglobalwin/formCombination/formCombination.vue';
import components from '@/components/iglobalwin/formComponents/index';
import customComponent from '@/components/tools/customComponent';
export default {
	props: {
		dialogVisible: {
			type: Boolean,
			default: false,
		},
		formData: {
			type: Object,
			default() {
				return {};
			},
		},
		attributes: {
			type: Object,
			default() {
				return {};
			},
		},
		colType: {
			type: String,
			default: '',
		},
		showBtn: {
			type: Boolean,
			default: true,
		},
		hideClose: {
			type: Boolean,
			default: false,
		},
		componentType: {
			default: '',
		},
	},
	data() {
		return {
			copyVisible: false,
			btnLoading: false,
		};
	},
	methods: {
		// 确定
		async confirm() {
			this.$refs.formName.validate(val => {
				if (val) {
					this.btnLoading = true;
					this.$emit('confirm', val => {
						this.reset(val);
					});
				}
			});
		},
		// 取消
		cancel() {
			this.btnLoading = true;
			this.reset();
		},
		// 重置
		reset(val = true) {
			this.btnLoading = false;
			if (val) {
				this.copyVisible = false;
				this.$refs.formName.reset();
			}
		},
		// 关闭
		close() {
			// 同步父组件数据
			this.$emit('close:dialogVisible', false);
			this.reset();
		},
		launchWhatsAppSignup() {
			this.$emit('launchWhatsAppSignup')
		}
	},
	watch: {
		dialogVisible: {
			handler(val) {
				this.copyVisible = val;
			},
		},
	},
	components: { ...components, formCombination, customComponent },
};
</script>

<style lang="scss">
.dialog-form-only {
  .el-dialog__body {
    padding-top: 20px;
  }
}
</style>
